import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import './index.css'
import 'font-awesome/css/font-awesome.min.css';

const Layout = ({ children, data }) => (
  <div>
    <Helmet
      defaultTitle='Membran Labs'
      titleTemplate='Membran Labs - %s'
      meta={[
        { name: 'description', content: 'Combining Music and Technology' },
        { name: 'keywords', content: 'Membran, Membran Labs, Music' },
      ]}
    />
    <div
      style={{
        margin: '0 auto',
        paddingTop: 0,
      }}
    >
      {children()}
    </div>
  </div>
)

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js